(() => {
  if (customElements.get("pdp-media-gallery")) {
    return;
  }

  class PdpMediaGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const mobileSwiper = this.dataset.swiperType == "mobile";
      const desktopSwiper = this.dataset.swiperType == "desktop";

      if (mobileSwiper) {
        const swiper = new Swiper(this, {
          direction: "horizontal",
          pagination: {
            el: this.querySelector(".pdp-media-gallery__pagination-mobile"),
            type: "fraction",
          },
          slidesPerView: 1,
        });

        const progressBar = new Swiper(this, {
          pagination: {
            el: this.querySelector(".pdp-media-gallery__progress-bar-mobile"),
            type: "progressbar",
          },
        });

        swiper.controller.control = progressBar;
      }

      if (desktopSwiper) {
        const main = this.querySelector(".swiper.main");
        const thumbsnails = this.querySelector(".swiper.thumbs");

        const thumbs = new Swiper(thumbsnails, {
          direction: "vertical",
          slidesPerView: 4,
          spaceBetween: 15,
          autoHeight: true
        });

        const swiper = new Swiper(main, {
          direction: "vertical",
          pagination: {
            el: this.querySelector(".pdp-media-gallery__pagination-desktop"),
            type: "fraction",
          },
          slidesPerView: 1,
          thumbs: {
              swiper: thumbs,
          },
          autoHeight: true,
          mousewheel: true
        });

        const progressBar = new Swiper(main, {
          direction: "vertical",
          pagination: {
            el: this.querySelector(".pdp-media-gallery__progress-bar-desktop"),
            type: "progressbar",
          },
        });

        swiper.controller.control = progressBar;
      }
    }
  }

  customElements.define("pdp-media-gallery", PdpMediaGallery);
})();
